import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  template: ``
})
export class RequestsComponent implements OnDestroy {

  protected invokedHttpRequests: Subscription[] = [];

  ngOnDestroy() {
    if (this.invokedHttpRequests.length > 0) {
      this.invokedHttpRequests.forEach(sub => sub.unsubscribe())
    }
  }

}
